const text = {
  // ACCESS: 'Access',
  ACCESS_DENIED: 'Access Denied',
  // ACTION: 'Action',
  // ACTION_DATE: 'Action Date',
  // ACTIVE: 'Active',
  // ACTIVE_QO: 'Active?',
  // ACTIVE_ON_CRIB_QO: 'Active on CIRB?',
  // ADDITIONAL_ATTRIBUTES: 'Additional Attributes',
  // ADDRESS: 'Address',
  // ADDRESS1: 'Address1',
  // ADDRESS2: 'Address2',
  // ADDRESS3: 'Address3',
  // ADDRESS4: 'Address4',
  // ADDRESSES: 'Addresses',
  // ADDRESSSCOPE: 'addressScope',
  // ADDRESSTYPE: 'addressType',
  // ADDRESS_FOR: 'Address For',
  // ADDRESS_LINE: 'Address Line',
  // ADDRESS_LINE1: 'Address Line 1',
  // ADDRESS_LINE2: 'Address Line 2',
  // ADDRESS_LINE3: 'Address Line 3',
  // ADDRESS_LINE4: 'Address Line 4',
  // ADDRESS_SOURCE: 'Address Source',
  // ADDRESS_TYPE: 'Address Type',
  // ADD_ADDRESS: 'Add Address',
  // ADMINISTRATION: 'Administration',
  // ADMINISTRATION_SECTION: 'Administration section',
  // AFFILIATIONS: 'Affiliations',
  // ALLOWED: 'Allowed',
  // AND: '...and...',
  // ANDY_TEST: 'Andy Test',
  APPLICATION_SUPPORTS_THE_MAINT:
    'application enables NCI, LPO, and CTSU staff to view Protocol Deviations entered via the standard CTSU Protocol Deviation Form in Rave during the form pilot.',
  // APPLIES_TO: 'Applies to',
  // ASSOCIATION: 'Association',
  // ATTRIBUTES: 'Attributes',
  // AUDIT_QO: 'Audit?',
  // ATTRIBUTE_NAME: 'Attribute Name',
  // ATTRIBUTE_VALUE: 'Attribute Value',
  // BROWSER: 'Browser',
  // BUTTON: 'button',
  // CANNOT_LOAD_REQUESTED_PAGE_AT: 'Cannot Load Requested Page At This Time',
  // CAREOF: 'CareOf',
  // CARE_OF: 'Care Of',
  // CATEGORY: 'Category',
  // CERTIFICATEID: 'certificateId',
  // CERTIFICATE_ID: 'Certificate ID',
  // CIRB: 'CIRB',
  // CITE: 'Cite',
  // CITY: 'City',
  CONTACT_HELP_DESK: {
    LINE_ONE: 'Please contact the',
    LINE_TWO: 'CTSU Help Desk',
    LINE_THREE: 'to request access'
  },
  // CLAIM_INSTITUTION: 'claim Institution',
  // CLAIM_PACKAGE: 'claim Package',
  // CLAIM_PACKAGE_CONTINUE_MSG:
  // eslint-disable-next-line max-len
  //   'This institution is part of a LAPS Package. Claiming a LAPS to your roster will add all tier 1, 2 and 3 sites under the package to your roster in a pending status. Would you like to continue?',
  // CLICK_A_NUMBER_BELOW_TO_VIEW_A: 'Select a tile from the list to view the related records for',
  // CLOSE: 'Close',
  // COMMENTS: 'Comments',
  // COMPLETION: 'Completion',
  // COMPLETION_DATE: 'Completion Date',
  // CONTACT: 'Contact',
  // CONTACTS: 'Contacts',
  // CONTACT_INFO: 'Contact Info',
  // CONTACT_STATUS: 'Contact Status',
  // CONTACT_TYPE: 'Contact Type',
  // COUNTRY: 'Country',
  // COURSENAME: 'courseName',
  // COURSE_DETAILS: 'Course Details',
  // COURSE_NAME: 'Course Name',
  // CREDENTIALING: 'Credentialing',
  // CREDENTIALING_SECTION: 'Credentialing section',
  // CREDENTIALS_FOR: 'Provider Credentials for',
  // CREDENTIAL_DESCRIPTION: 'Credential Description',
  // CREDENTIAL_TYPE: 'Credential Type',
  // CREDITS: 'credits',
  // CREDITS1: 'Credits',
  // CTEP: 'CTEP',
  // CTEP_IAM_LOGIN: 'CTEP-IAM Login',
  // CTEP_ID: 'CTEP ID',
  // CTEP_PERSON_ID: 'CTEP Person ID',
  // CTEP_QO: 'CTEP?',
  // CTEP_ROSTER_QO: 'CTEP Roster?',
  // CTMB_QO: 'CTMB?',
  // CTMB_DETAILS: 'CTMB Details',
  // CTSU: 'CTSU',
  // DATECOMPLETED: 'dateCompleted',
  // DATEEXPIRES: 'dateExpires',
  // DATESTARTED: 'dateStarted',
  // DATE_STARTED: 'Date Started',
  // DEGREES_BOARD_CERTIFICATIONS: 'Degrees, Board Certifications, and Licenses',
  // DESIGN: 'Design',
  // EDIT: 'Edit',
  // EFFECTIVE_DATE: 'Effective Date',
  // EMPTY: 'empty',
  // END_DATE: 'End Date',
  // ENTER: 'Enter',
  // ENTER_USER: 'Person Finder',
  // ESYS_STATUS: 'Esys Status',
  // EXPIRATION_DATE: 'Expiration Date',
  // EXPIRES: 'Expires',
  // EXPIRY: 'Expiry',
  // EXPIRY_DATE: 'Expiry Date',
  // FEEDBACK: 'Feedback',
  // FIRST_NAME: 'First Name',
  // FROM_STATE: 'From State',
  // FWA_NUMBER: 'FWA Number',
  // GLOBAL_SEARCH: 'Global Search',
  // GO: 'GO!',
  // GROUP: '-group',
  // GROUPINSTID: 'groupInstId',
  // GROUP_ID: 'Group ID',
  // GROUP_PERSON_ID: 'Group Person ID',
  // HERE: 'here',
  // HIDDEN: 'hidden',
  // IMPERSONATE: 'Impersonate',
  // INFOSOURCE: 'infoSource',
  // INSIGHTS: 'Insights',
  // INSTITUTION: 'Institution',
  // INSTITUTIONS: 'Institutions',
  // INSTITUTION_AFFILIATION_DETAIL: 'Institution Affiliation Details',
  // INSTITUTION_AND_PERSON_SECTION: 'Institution and Person sections',
  // INSTITUTION_CTEP_DETAILS: 'Institution CTEP Details',
  // INSTITUTION_CTEP_ID: 'Institution CTEP ID',
  // INSTITUTION_FINDER: 'Institution Finder',
  // INSTITUTION_GROUP_ID: 'Institution Group ID',
  // INSTITUTION_SEARCH: 'Institution Search',
  // INSTITUTION_ROSTER_BROWSER: 'Institution Roster Browser',
  // IN_THE: 'In the',
  // IRBS: 'IRBS',
  // IRB_NUMBER: 'IRB Number',
  // ISACTIVEYN: 'isActiveYn',
  // ISCTEPROSTER: 'isCtepRoster',
  // ISPREFERRED: 'isPreferred',
  // IS_ASSOCIATED_WITH_THE_FOLLOWI: 'is associated with the following treating sites',
  // LAST_NAME: 'Last Name',
  // LEAD_ORGANIZATION: 'Lead Organization',
  // LEFT: 'left',
  // LMS_TRAINING: 'LMS Training',
  // LOGOUT: 'Logout',
  // MEMBERROLE: 'memberRole',
  // MEMBERROLESTATUS: 'memberRoleStatus',
  // MEMBERSTUDYTYPE: 'memberStudyType',
  // MEMBER_ID: 'Member ID',
  // MEMBER_ROLE: 'Member Role',
  // MENBER_ROLE_STATUS: 'Member Role Status',
  // MENU: '☰ Menu',
  // MIDDLE_NAME: 'Middle Name',
  // MY_NMC_BROWSER: 'My NMC Browser',
  // MY_ROSTER_MAINTENANCE_TASKS: 'My Roster Maintenance Tasks',
  // MY_TASKS: 'My Tasks',
  // NA: 'NA',
  // NAME: 'Name',
  // NCI_CTEP_REGISTRATION: 'NCI-CTEP Registration',
  // NCI_REGISTRATION_STATUS: 'NCI Registration Status',
  // NCI_REGISTRATION_EXPIRY_DATE: 'NCI Registration Expiry Date',
  // NCI_REGISTRATION_PRIMARY_INST: 'Primary Institution',
  // NCI_REGISTRATION_REGISTRED_IN_RCR: 'Registered in RCR',
  // NCTN_GROUP_ID: 'NCTN Group ID',
  // NO: 'No',
  // NOTIFY_DATE: 'Notify Date',
  // NO_RECORD_FOUND_FOR: 'No Record found for',
  // NO_RECORD_S_FOUND: 'No Record(s) Found',
  // NXT: 'NXT',
  // OBJECT_TYPE: 'Object Type',
  // OF_THE_ROSTER_MAINTENANCE_APPL: 'of the Roster Maintenance application to complete roster-related tasks.',
  // OGN_CATEGORY: 'OGN Category',
  // ON_THE_GROUP: 'on the Group',
  // OPEN: 'open',
  // OPTIONAL_ATTRIBUTES_FOR: 'Optional Attributes for',
  // OWNER: 'Owner',
  // PAGE: 'Page',
  // PAGE_IS_LOADING_PLEASE_WAIT: 'Page is Loading. Please wait.',
  // PARENT: 'parent',
  // PARENT1: 'parent+',
  // PARENTCTEPID: 'parentCtepId',
  // PARENTHESES_OPEN: '(',
  // PARENTHESES_CLOSE: ')',
  // PARENT_CTEP_ID: 'Parent CTEP ID',
  // PERSON: 'Person',
  // PERSON_ATTRIBUTES: 'Person Attributes',
  // PERSON_DETAILS: 'Person Details',
  // PERSON_FINDER: 'Person Finder',
  // PERSON_INSIGHTS: 'Person Insights',
  // PERSON_NAME: 'Person Name',
  // PERSON_ROSTER_STATUS: 'Person Roster Status',
  // PERSON_ROSTER_STATUS_DATE: 'Person Roster Status Date',
  // PER_ID: 'Per ID',
  // PIPE_CHAR: '|',
  // PLACE_AT_A_GLANCE_CODE_HERE_T: 'Place AT A GLANCE code here (TABLE to /TABLE)',
  // PLEASE_CONTACT_CTSU_HELP_DESK: 'Please Contact CTSU Help Desk',
  // PLEASE_TRY_AGIAN: '! Please try agian.',
  // PRACTICE_SITES: 'Practice Sites',
  // PREFERRED_Q: 'Preferred?',
  // PREFERRED_SITE_QO: 'Preferred Site?',
  // PREV: 'PREV',
  // PRIMARY_QO: 'Primary?',
  // PROGRESS: 'progress',
  // PROGRESS1: 'Progress',
  PROTOCOL_DEVIATIONS: 'Protocol Deviations',
  // PROTOCOL_NUMBER: 'Protocol Number',
  // PROVIDER: 'Provider',
  // PROVIDER_CTEP_ID: 'Provider CTEP ID',
  // PROVIDER_ADDRESS: 'Provider Address:',
  // REGISTRATION_DATA: 'Registration Data',
  // REGISTRATION_TYPE: 'Registration Type',
  // RELATED_OBJ: 'Related Obj',
  // REQUIRED_ATTRIBUTES_FOR: 'Required Attributes for',
  // RESET: 'Reset',
  // RESTRICT_REASON: 'Restrict Reason',
  // RESTRICTION_TYPE: 'Restriction Type',
  // ROLES: 'Roles',
  // ROLES_BROWSER: 'Roles Browser',
  // ROLE_ASSIGNMENT_ID: 'Role Assignment ID',
  // ROLE_ID: 'Role ID',
  // ROLE_NAME: 'Role Name',
  // ROLE_S: "Role's",
  // ROLE_TYPE: 'Role Type',
  // ROSTER: 'Roster',
  // ROSTER_MAINTENANCE: 'Roster Maintenance',
  // ROSTER_OWNER: 'Roster Owner',
  // ROSTER_OWNER_C: 'Roster Owner:',
  // ROSTER_OWNERS_CAN_REVIEW_AND:
  //   ', roster owners can review and take action on roster requests, including claiming packages, institutions and persons, updating attributes and adding person roles.',
  // ROSTER_OWNERS_CAN_REVIEW_AND1:
  // eslint-disable-next-line max-len
  //   ', roster owners can review and edit institution or person data relevant to their roster(s). A browser is also available in each of these section to navigate roster records.',
  // ROSTER_OWNER_STAFF_WITH_APPROP: 'Roster owner staff with appropriate privileges are able to',
  // SAVE_CHANGE: 'Save Change',
  // SCORE: 'score',
  // SCORE1: 'Score',
  // SEARCH_BY_INSTITUTION_CTEP_ID: 'Search by Institution CTEP ID',
  // SEARCH_RESULT_FOR: "Search Result for '",
  // SELECT: 'Select',
  // SELECT_STAFF_CAN_COMPLETE_AD:
  //   ', select staff can complete administrator tasks, including management of unregistered institutions, protocols, and maintenance of institution FWA data.',
  // SITECTEPID: 'siteCtepId',
  // SITE_CTEP_ID: 'Institution CTEP ID',
  // SITE_RESTRICTIONS: 'Site Restrictions',
  // SOMETHING_WENT_WRONG: 'Something went wrong.',
  // START_DATE: 'Start Date',
  // STATE: 'State',
  // STATE_PROVINCE: 'State/Province',
  // STATUS: 'Status',
  // STATUS_DATE: 'Status Date',
  // STOP_IMPERSONATE: 'Stop Impersonate',
  // STUDY_TYPE: 'Study Type',
  // SUBMIT: 'Submit',
  // SEMI_COLON: ':',
  // SINGLE_QUOTE: "'",
  // SKIP_TO_CONTENT: 'Skip to content',
  // SPACE: '',
  // SYMBOL_CARET_DOWN: '▼',
  // SAVE: 'Save',
  // TEXT: 'text',
  THE: 'The',
  // TIER_1_CTEP_ID: 'Tier 1 CTEP ID',
  // TIMESPENT: 'timeSpent',
  // TIME_SPENT: 'Time Spent',
  // TITLE: 'Title',
  // TO: 'To',
  // TO_STATE: 'To State',
  // TRAINING: 'Training',
  // TREATMENT_SITE_ASSOCIATION_STATUS: 'Treatment Site Association Status',
  // TYPE: 'Type',
  // USAGE: 'Usage',
  // USER: 'User',
  // USE_DIFFERENT_SECTIONS: 'use different sections',
  // NO_ROLE_MESSAGE: 'You are not authorized to perform the requested operation.',
  // VAL: 'Val 1',
  // VAL1: 'Val 2',
  // VALUE: 'Value',
  // VIEW: 'VIEW',
  WELCOME: 'Welcome',
  // Y: 'Y',
  // YES: 'Yes',
  // ZIPCODE: 'ZipCode',
  // ZIP_CODE: 'Zip Code',
  IDP: 'IDP'
};
export default text;
